import {
  Pipe,
  PipeTransform
} from '@angular/core';

@Pipe({
  standalone: true,
  name: 'cdn'
})
export class CdnPipe implements PipeTransform {
  transform(id: string, type: 'image' | 'document'): string {
    return `cdn/${type}?id=${id}`;
  }
}
